import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector, change } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'
import textArea from '../common/form/textArea'
import { createNumberMask, createTextMask } from 'redux-form-input-masks';


import { initFormCreat } from './boletoAction'
import Select from '../common/form/select'


const currencyMask = createNumberMask({
  prefix: '',
  suffix: '',
  decimalPlaces: 2,
  locale: 'pt-br',
})


class BoletoFormCreat extends Component {

  constructor(props) {
    super(props)
    this.state = {
      desativaPercentualDesconto: false, desativaValorDesconto: false,
      desativaPercentualMulta: true, desativaValorMulta: true,
      desativaPercentualJuro: true, desativaValorJuro: true
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.options !== this.props.options) {
      // trigger a value change to the first option somehow
    }
    
  }
  getListaTipoDesconto = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Desconto" });
    lista.push({ chave: 1, valor: "Valor Fixo" });
    lista.push({ chave: 2, valor: "Percentual" });
    lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
  }

  getListaTipoJuro = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Juros" });
    lista.push({ chave: 1, valor: "Valor Dia Atraso" });
    lista.push({ chave: 2, valor: "Taxa Mensal" });
    //lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
}

getListaTipoMulta = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Multa" });
    lista.push({ chave: 1, valor: "Valor Multa" });
    lista.push({ chave: 2, valor: "Percentual" });
    //lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
}


  handleChange = event => {
    this.desativaEdtValorPercentualDesconto(event.target.value)

  };

  desativaEdtValorPercentualDesconto = (tipoDesconto) => {
    let edtValor = true;
    let edtPercentual = true;

    if (tipoDesconto == 0) {
      edtValor = true;
      edtPercentual = true;
      this.props.dispatch(change('boletoFormCreate', 'valor_desconto', '0'));
      this.props.dispatch(change('boletoFormCreate', 'percentual_desconto', '0'));
    }
    if (tipoDesconto == 1) {
      edtValor = false;
      edtPercentual = true;
      this.props.dispatch(change('boletoFormCreate', 'percentual_desconto', '0'));
    }
    if (tipoDesconto == 2 || tipoDesconto == 3) {
      edtValor = true;
      edtPercentual = false;
      this.props.dispatch(change('boletoFormCreate', 'valor_desconto', '0'));
    }

    this.setState({ ...this.state, desativaValorDesconto: edtValor, desativaPercentualDesconto: edtPercentual })
  }


  tipoJuroChange = event => {
    this.desativaEdtValorPercentualJuro(event.target.value)
};

desativaEdtValorPercentualJuro = (tipoJuro) => {
    let edtValorJuro = true;
    let edtPercentualJuro = true;

    if (tipoJuro == 0) {
        edtValorJuro = true;
        edtPercentualJuro = true;
        this.props.dispatch(change('boletoFormCreate', 'valor_juro', '0'));
        this.props.dispatch(change('boletoFormCreate', 'percentual_juro', '0'));
    }
    if (tipoJuro == 1) {
        edtValorJuro = false;
        edtPercentualJuro = true;
        this.props.dispatch(change('boletoFormCreate', 'percentual_juro', '0'));
    }
    if (tipoJuro == 2 || tipoJuro == 3) {
        edtValorJuro = true;
        edtPercentualJuro = false;
        this.props.dispatch(change('boletoFormCreate', 'valor_juro', '0'));
    }

    this.setState({ ...this.state, desativaValorJuro: edtValorJuro, desativaPercentualJuro: edtPercentualJuro })
}

tipoMultaChange = event => {
    this.desativaEdtValorPercentualMulta(event.target.value)
};
desativaEdtValorPercentualMulta = (tipoMulta) => {
    let edtValorMulta = true;
    let edtPercentualMulta = true;
    console.log(tipoMulta)

    if (tipoMulta == 0 || tipoMulta == 3) {
        edtValorMulta = true;
        edtPercentualMulta = true;
        this.props.dispatch(change('boletoFormCreate', 'valor_multa', '0'));
        this.props.dispatch(change('boletoFormCreate', 'percentual_multa', '0'));
    }
    if (tipoMulta == 1) {
        edtValorMulta = false;
        edtPercentualMulta = true;
        this.props.dispatch(change('boletoFormCreate', 'percentual_multa', '0'));
    }
    if (tipoMulta == 2) {
        edtValorMulta = true;
        edtPercentualMulta = false;
        this.props.dispatch(change('boletoFormCreate', 'valor_multa', '0'));
    }

    this.setState({ ...this.state, desativaValorMulta: edtValorMulta, desativaPercentualMulta: edtPercentualMulta })
}


  componentWillMount() {
    this.desativaEdtValorPercentualDesconto(this.props.tipo_desconto);
    this.desativaEdtValorPercentualJuro(this.props.tipo_juro);
    this.desativaEdtValorPercentualMulta(this.props.tipo_multa);

  }



  render() {
    const { handleSubmit, readOnly} = this.props

    const currencyFormatter = (value) => {
      if (value === undefined) value = 0
      var valor = value;

      valor = valor + '';
      valor = parseInt(valor.replace(/[\D]+/g, ''));
      valor = valor + '';
      valor = valor.replace(/([0-9]{2})$/g, ",$1");

      if (valor.length > 6) {
        valor = valor.replace(/([0-9]{3}).([0-9]{2}$)/g, ".$1,$2");
      }

      return valor
    }



    return (
      <form role='form' onSubmit={handleSubmit}>

        <div className="box-body">


          <Field name='idcliente' component={labelAndInput}
            label='Cliente'
            cols='12 4'
            pattern="[0-9]*"
            type='number'
            inputMode="numeric"
            placeholder='Digite o Id do cliente' />

          <Field name='valor' component={labelAndInput}
            label='Valor'
            pattern="[0-9]*"
            cols='12 2'
            className='valor_monetario form-control'
            inputMode="numeric"
            readOnly={readOnly}
            format={currencyFormatter}
          />

          <Field name='quantidade_parcelas' component={labelAndInput}
            cols='12 2'
            label='Quantidade de Parcela'
            pattern="[0-9]*"
            type='number'
            inputMode="numeric"
            readOnly={readOnly} />

          <Field name='dt_vencimento' component={labelAndInput}
            label='Data Vencimento'
            cols='12 3'
            type='date'
            readOnly={readOnly} />

          <Field name='descricao' component={textArea}
            cols='12 12'
            type="textare"
            label='Descrição'
            readOnly={readOnly} />

          <Field name='tipo_desconto' component={Select}
            cols='12 4'
            label='Tipo Desconto (Válido até a Data de Venc.)'
            lista={this.getListaTipoDesconto()}
            onChange={this.handleChange}
            readOnly={readOnly} />
          <Field name='valor_desconto' component={labelAndInput}
            type='numeric' cols='12 2'
            label='Valor Desconto'
            placeholder='Valor Desconto'
            className='valor_monetario form-control'
            pattern="[0-9]*"
            inputMode="numeric"
            {...currencyMask}
            readOnly={this.state.desativaValorDesconto} />

          <Field name='percentual_desconto' component={labelAndInput}
            type='numeric' cols='12 2'
            label='Percentual Desconto'
            placeholder='Percentual Desconto'
            className='valor_monetario form-control'
            pattern="[0-9]*"
            inputMode="numeric"
            {...currencyMask}
            readOnly={this.state.desativaPercentualDesconto} />

<Field name='tipo_multa' component={Select}
                        cols='12 4'
                        label='Tipo Multa'
                        lista={this.getListaTipoMulta()}
                        onChange={this.tipoMultaChange}
                        readOnly={readOnly} />
                    <Field name='valor_multa' component={labelAndInput}
                        type='numeric' cols='12 2'
                        label='Valor multa'
                        placeholder='Valor Multa'
                        className='valor_monetario form-control'
                        pattern="[0-9]*"
                        inputMode="numeric"
                        {...currencyMask}
                        readOnly={this.state.desativaValorMulta} />

                    <Field name='percentual_multa' component={labelAndInput}
                        type='numeric' cols='12 2'
                        label='Percentual Multa'
                        placeholder='Percentual Multa'
                        className='valor_monetario form-control'
                        pattern="[0-9]*"
                        inputMode="numeric"
                        {...currencyMask}
                        readOnly={this.state.desativaPercentualMulta} />

                    <Field name='tipo_juro' component={Select}
                        cols='12 4'
                        label='Tipo Juro'
                        lista={this.getListaTipoJuro()}
                        onChange={this.tipoJuroChange}
                        readOnly={readOnly} />
                    <Field name='valor_juro' component={labelAndInput}
                        type='numeric' cols='12 2'
                        label='Valor Juro'
                        placeholder='Valor Juro'
                        className='valor_monetario form-control'
                        pattern="[0-9]*"
                        inputMode="numeric"
                        {...currencyMask}
                        readOnly={this.state.desativaValorJuro} />

                    <Field name='percentual_juro' component={labelAndInput}
                        type='numeric' cols='12 2'
                        label='Percentual Juro'
                        placeholder='Percentual Juro'
                        className='valor_monetario form-control'
                        pattern="[0-9]*"
                        inputMode="numeric"
                        {...currencyMask}
                        readOnly={this.state.desativaPercentualJuro} />

        </div>
        <div className="boxfooter">
          <button type='submit'
            className={`btn btn-${this.props.submitClass}`}>
            <i className={`fa fa-${this.props.iconSubmit}`}></i>
            <span className='space-icon'>{this.props.submitLabel}</span>
          </button>
          <button type='button' className="btn btn-default"
            onClick={this.props.initFormCreat} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
        </div>
      </form>
    )
  }
}

const normalizePhone = value => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`
}




BoletoFormCreat = reduxForm({ form: 'boletoFormCreate'/*, destroyOnUnmount: false, enableReinitialize: true*/ })(BoletoFormCreat)
const selector = formValueSelector('boletoFormCreate')
const mapStateToProps = state => ({

})
const mapDispatchToProps = dispatch => bindActionCreators({ initFormCreat }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(BoletoFormCreat)



// WEBPACK FOOTER //
// ./src/boleto/boletoFormCreat.jsx